/* eslint-disable complexity */
import React from "react";
import { FormattedAmount } from "../../../data-grid/components/formatted-amount";
import { FormattedNumber } from "@futrli/localisation";
import { MAX_DIGITS_IN_CELL } from "../../../../core/constants";
import { amountToPence } from "../../../../core/formatters";
import { MAX_DECIMALS } from "../../types";

interface FreestyleContentValueProps {
  blankDataValue?: string;
  format: 'currency' | 'decimal',
  maximumFractionDigits?:  number;
  minimumFractionDigits?: number;
  showDecimals?: boolean;
  value: string | number;
}

export const FreestyleContentValue = ({
  blankDataValue = '-',
  format = 'currency',
  maximumFractionDigits = MAX_DECIMALS,
  minimumFractionDigits = MAX_DECIMALS,
  showDecimals = true,
  value
}: FreestyleContentValueProps) => {
  const numValue = Number(value);

  if(value === '') {
    return (
      <>{blankDataValue}</>
    )
  }
  else if(format === 'currency') {
    return (
      <FormattedAmount
        amount={amountToPence(numValue)}
        maxDigits={MAX_DIGITS_IN_CELL}
        hideDecimals={!showDecimals}
      />
    )
  }
  else {
    return (
      <FormattedNumber
        style="decimal"
        value={showDecimals ? Number(value) : Math.round(Number(value))}
        maximumFractionDigits={showDecimals ? maximumFractionDigits : 0}
        minimumFractionDigits={showDecimals ? minimumFractionDigits : 0}
      />
    )
  }
}
